"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledSectionTitle = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledSectionTitle = styled_components_1.default.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 2.25rem;

  .title-actions {
    display: flex;
    align-items: center;
    gap: ${({ theme }) => theme.spacing(1)};
  }
`;
